import { withPrefix } from 'gatsby'
import WordData from '../utils/WordData'


const LOCALE = process.env.LOCALE;
const italatam = LOCALE === 'es-AR';

const $Arrastra = italatam ? 'Arrastrá' : 'Arrastra';
const ASSETS_BASE_URL = withPrefix('/phaser/images')
const ASSETS_SOUNDS_BASE_URL = withPrefix('/phaser/sounds')

const TOOLBOX_CONFIG_PADDING = {
  height: { desktop: 120, mobile: 100 },
}
const DEPTH_ORDER = {
  minimap: 100,
  popups: 90,
  toolbox: 21,
  viewport_fill: 50,
  drag_element_ondrop: 1,
  drag_element_ondrag: 30,
  drop_word: 25,
  timer: 15,
  btnEndGame: 22,
}
export const COLORS = {
  white: 0xFFFFFF,
  primaryPink: 0xC03480,
  accentPink: 0xCF1783,
  secondaryPink: 0xC81778,
  primaryBlue: 0x04205D,
  accentBlue: 0x051D53,
  HEX: {}
};
for (let i in COLORS) {
  if (i !== "HEX")
    COLORS.HEX[i] = "#" + COLORS[i].toString(16).padStart(6, "0");
}


export const CUSTOM_FONTS = ["BwModelica-ExtraBold", "BwModelica-ExtraBoldItalic", "BwModelica-Bold", "BwModelicaSS01-Bold"]
export const POINTS_BY_WORD = 2

export const MAP_CONFIG = {
  paddingBottom: TOOLBOX_CONFIG_PADDING.height,
}

export const MINIMAP_CONFIG = {
  posX: { desktop: 10, mobile: 10 },
  posY: { desktop: 10, mobile: 10 },
  relation: { desktop: 0.08, mobile: 0.07 },
  borderColor: COLORS.primaryBlue,
  borderOpacity: 1,
  borderWeight: { desktop: 5, mobile: 2 },
  borderDepth: DEPTH_ORDER.minimap, // zIndex
}

export const TOOLBOX_CONFIG = {
  heightPercent: 0.2,
  height: TOOLBOX_CONFIG_PADDING.height,
  fillColor: COLORS.accentPink,
  fillOpacity: 1,
  fillWeight: 5,
  depth: DEPTH_ORDER.toolbox,
  paddingLeft: { desktop: 100, mobile: 10 },
  paddingRight: { desktop: 250, mobile: 10 },
  paddingTop: { desktop: 25, mobile: 70 },
  shadowParticle: ASSETS_BASE_URL + "/white.png"
}

export const TOOLBOX_INSTRUCTIONS_CONFIG = {
  text:
    $Arrastra + ' cada palabra y ubícala en su cajón correspondiente para armar la frase',
  style: {
    desktop: {
      fontFamily: 'BwModelicaSS01-Bold',
      color: COLORS.HEX.accentBlue,
      fontSize: '16px',
      align: 'center',
    },
    mobile: {
      fontFamily: 'BwModelicaSS01-Bold',
      color: COLORS.HEX.accentBlue,
      fontSize: '15px',
      align: 'center',
    },
  },
  maxwidth: 728,
  marginX: 20,
  backgroundPadding: {
    hor: 20,
    ver: 10
  },
  marginBottom: { desktop: 25, mobile: 10 },
  depth: DEPTH_ORDER.toolbox,
}

export const WORD_GRID_GAP_COLUMN = 15
export const WORD_GRID_GAP_ROW = 30

export const VIEWPORT_CONFIG = {
  borderWeight: 30,
  borderColor: COLORS.white,
  borderOpacity: 0,
  fillColor: COLORS.white,
  fillOpacity: 0.7,
  fillDepth: DEPTH_ORDER.viewport_fill,
}

export const DRAG_ELEMENT_CONFIG = {
  dropDepth: DEPTH_ORDER.drag_element_ondrop,
  dragDepth: DEPTH_ORDER.drag_element_ondrag,
  sfx: {
    "drop-wrong": [ASSETS_SOUNDS_BASE_URL + "/drop-wrong.wav"], "drop-correct": [ASSETS_SOUNDS_BASE_URL + "/drop-correct.wav"]

    , "pickup": [ASSETS_SOUNDS_BASE_URL + "/pickup.wav"]
  }
}

export const DROP_WORD_CONFIG = {
  depth: DEPTH_ORDER.drop_word,
}

export const TIMER_CONFIG = {
  posX: {
    //desktop: (w) => w / 2 - 200 / 2,
    desktop: w => w - 190,
    mobile: w => (w > 600 ? w / 2 : 10),
  },
  posY: {
    desktop: h => 107,
    mobile: (h, w) => (w > 600 ? 10 : 57),
  },
  text: 'Tiempo: $',
  iconSrc: ASSETS_BASE_URL + '/timer_icon.svg',
  bgSrc: ASSETS_BASE_URL + '/pill-container-white.svg',
  displayWidth: {
    desktop: 152, mobile: 134,
  },
  style: {
    desktop: {
      fontFamily: 'BwModelica-ExtraBold',
      color: COLORS.HEX.primaryBlue,
      fontSize: '16px',
      align: 'left',
    },
    mobile: {
      fontFamily: 'BwModelica-ExtraBold',
      color: COLORS.HEX.primaryBlue,
      fontSize: '14px',
      align: 'left',
    },
  },
  depth: DEPTH_ORDER.timer,
}

export const POINTS_CONFIG = {

  posX: {
    //desktop: (w) => w / 2 - 200 / 2,
    desktop: w => w - 190,
    mobile: w => (w > 600 ? w / 2 - 134 - 10 : 10),
  },
  posY: {
    desktop: h => 57,
    mobile: (h, w) => 10,
  },
  text: "Puntos: $ ",
  depth: DEPTH_ORDER.timer,
  iconSrc: ASSETS_BASE_URL + '/points_icon.svg',
  bgSrc: ASSETS_BASE_URL + '/pill-container-white.svg',
  displayWidth: {
    desktop: 152,
    mobile: 134
  },
  style: {
    desktop: {
      fontFamily: 'BwModelica-ExtraBold',
      color: COLORS.HEX.primaryBlue,
      fontSize: '16px',
      align: 'left',
    },
    mobile: {
      fontFamily: 'BwModelica-ExtraBold',
      color: COLORS.HEX.primaryBlue,
      fontSize: '14px',
      align: 'left',
    },
  },
}

export const BTN_ENDGAME_CONFIG = {
  posX: {
    desktop: gameWidth => gameWidth - 120,
    mobile: gameWidth => gameWidth / 2,
  },
  posY: {
    desktop: gameHeight => gameHeight - TOOLBOX_CONFIG_PADDING.height.desktop / 2 + 15,
    mobile: gameHeight => gameHeight - 32,
  },
  text: 'Finalizar juego',
  fillColor: COLORS.primaryBlue,
  fillColorPressed: COLORS.white,
  style: {
    fixedWidth: 204,
    fixedHeight: 62,
    fontFamily: 'BwModelica-ExtraBoldItalic',
    color: COLORS.HEX.white,
    pressColor: COLORS.accentPink,
    fontSize: '25px',
    align: 'center',
  },
  depth: DEPTH_ORDER.btnEndGame,
}

export const MAX_SCROLL_VELOCITY = 300
export const DEACELERATION_FACTOR = 0.1
export const DRAG_FACTOR = 1.3
export const AXIS_NAVIGATION = 1 // *-1 invert navigation

export const TIMER_DEFAULT_VALUES = {
  frequency: 1000,
  incrementFactor: -1,
  initialValue: 2 * 60, //SEGUNDOS
  limitTime: 0,
}

export const DEFAULT_WORD_LIST = [
  new WordData({
    stickPosX: 231,
    stickPosY: 457.6,
    word: 'san',
    isLocked: false,
    lockedSrc: ASSETS_BASE_URL + '/park/words_box_fill/S_san.png',
    dragSrc: ASSETS_BASE_URL + '/park/words_box_fill/B_san.png',
    emptySrc: ASSETS_BASE_URL + '/park/words_box_empty/S3.png', // word.lenght
    stickSrc: ASSETS_BASE_URL + '/park/words_stick/B_san.png',
  }),
  new WordData({
    stickPosX: 1175.3,
    stickPosY: 962.27,
    word: 'valentin',
    isLocked: false,
    lockedSrc: ASSETS_BASE_URL + '/park/words_box_fill/S_valentin.png',
    dragSrc: ASSETS_BASE_URL + '/park/words_box_fill/B_valentin.png',
    emptySrc: ASSETS_BASE_URL + '/park/words_box_empty/S8.png', // word.lenght
    stickSrc: ASSETS_BASE_URL + '/park/words_stick/B_valentin.png',
  }),
]


export const WORD_BOX_STYLE = {
  backgroundColor: COLORS.white,
  borderColor: COLORS.primaryPink,
  fillOpacity: 1,
  borderOpacity: 0,
  borderRadius: 4,
  borderSize: 2,
  padding: {
    x: 2, y: 3
  },
  letterGap: {
    desktop: 4,
    mobile: 2
  },
  fontStyle: {
    mobile: {
      fontSize: "16px",
      color: COLORS.HEX.primaryBlue,
      fontFamily: 'BwModelica-Bold'
    },
    desktop: {
      fontSize: "20px",
      color: COLORS.HEX.primaryBlue,
      fontFamily: 'BwModelica-Bold'
    }
  }
}

export const CONFIG_BTN_FULLSCREEN = {
  marginTop: { desktop: 30, mobile: 25 },
  marginRight: { desktop: 65, mobile: 25 },
  to_open: ASSETS_BASE_URL + "/icon-full-screen.svg",
  to_exit: ASSETS_BASE_URL + "/icon-full-screen-active.svg"
}

export const CONFIG_WIN_POINTS_MESSAGE = {
  src: ASSETS_BASE_URL + "/ganaste-puntos.svg",
  depth: DEPTH_ORDER.popups,
  wordsSpacing: 5,
  padding_start: 60,
  pretext: {
    text: "GANASTE",
    style: {
      fontSize: "20px",
      color: COLORS.HEX.primaryBlue,
      fontFamily: 'BwModelica-ExtraBold'
    }
  },
  pointstext: {
    text: (n) => (`${n} punto${n !== 1 ? "s" : ""}`),
    style: {
      fontSize: "20px",
      color: COLORS.HEX.primaryPink,
      fontFamily: 'BwModelica-ExtraBold'
    }
  }
}

export const MELODYS = {
  melody_1: ASSETS_SOUNDS_BASE_URL + "/melody_1.mp3",
  melody_2: ASSETS_SOUNDS_BASE_URL + "/melody_2.mp3",
  victory_sound: ASSETS_SOUNDS_BASE_URL + "/victory.wav",
  seconds_to_points: ASSETS_SOUNDS_BASE_URL + "/second-to-point.wav",
  volume: 0.1
}

export const CONFIG_BTN_MELODY = {
  marginTop: { desktop: CONFIG_BTN_FULLSCREEN.marginTop.desktop, mobile: CONFIG_BTN_FULLSCREEN.marginTop.mobile },
  marginRight: { desktop: CONFIG_BTN_FULLSCREEN.marginRight.desktop + 50, mobile: CONFIG_BTN_FULLSCREEN.marginRight.mobile + 50 },
  on: ASSETS_BASE_URL + "/icon-audio-on.svg",
  off: ASSETS_BASE_URL + "/icon-audio-off.svg"


}

export const INTRO_TEXT_CONFIG = {
  animation:ASSETS_BASE_URL+"/dragmove-animation.gif",
  text: {
    mobile: [$Arrastra + " la pantalla y", "podrás ver", "todo el escenario"],
    desktop: [$Arrastra + " la pantalla y podrás ver todo el escenario"]
  },
  depth: 2,
  fontStyle: {
    mobile: {
      fontSize: "24px",
      "align": "center",
      color: COLORS.HEX.white,
      fontFamily: 'BwModelica-ExtraBold'
    },
    desktop: {
      fontSize: "32px",
      color: COLORS.HEX.white,
      fontFamily: 'BwModelica-ExtraBold'
    }
  }
}
export const SECONDS_TO_POINTS = 1;